export default __webpack_public_path__ + "b740955fac2fd300d67163f80547bc60.svg";